import React, { useState } from "react";
import GenerateQuotationComponent from "./generate-quotation.component";
import { IQuotationCard } from "../quotation-card/types";
import { CARD_TYPES } from "../quotation-card/data";
import { useQuotationsContext } from "src/context/quotations-context";
import { getCurrentDate } from "src/helpers";
import { useQuotationsContextFcl } from "src/context/quotations-context-fcl";

const GenerateQuotationContainer = ({ clicked }: any) => {
  const { formikQuotation } = useQuotationsContext();
  const { formikQuotationFcl } = useQuotationsContextFcl();

  const [quotationTypes, setQuotationTypes] = useState<IQuotationCard[]>([
    {
      id: 1,
      title: "Internal Quotation",
      value: "internal",
      description: "Make a query and adjust results",
      isActive: false,
    },
    {
      id: 2,
      title: "Custom Quotation",
      value: "custom",
      description: "Create entirely from scratch",
      isActive: false,
    },
  ]);

  const [serviceTypes, setServiceType] = useState<IQuotationCard[]>([
    {
      id: 1,
      title: (
        <p>
          Less Container Load <br />
          (LCL)
        </p>
      ),
      value: "lcl",
      description: "Make a query and adjust results",
      isActive: false,
      image: "/assets/images/mcs-less-container.svg",
    },
    {
      id: 2,
      title: (
        <p>
          Full Container Load <br />
          (FCL)
        </p>
      ),
      value: "fcl",
      description: "Create entirely from scratch",
      isActive: false,
      image: "/assets/images/mcs-full-container-load.svg",
    },
    {
      id: 3,
      title: "Air",
      value: "air",
      description: "Make a query and adjust results",
      isActive: false,
      image: "/assets/images/mcs-air.svg",
      comingSoon: true,
    },
  ]);

  const handleCardClick = (value: string, type: CARD_TYPES) => {
    console.log("type", type, value);

    if (type == CARD_TYPES.QUOTATION_TYPE) {
      const updatedCardData = quotationTypes.map((card) => ({
        ...card,
        isActive: card.value === value,
      }));
      formikQuotation?.setFieldValue("quotation_type", value);
      setQuotationTypes(updatedCardData);
    } else {
      if (serviceTypes.find((c) => c.value === value)?.comingSoon) {
        return;
      }

      const updatedCardData = serviceTypes.map((card) => ({
        ...card,
        isActive: card.value === value,
      }));

      formikQuotation?.setFieldValue("service_type", value);
      formikQuotation?.setFieldValue("quotation_type", "external");
      formikQuotation?.setFieldValue("date", getCurrentDate());

      formikQuotationFcl?.setFieldValue("service_type", value);
      formikQuotationFcl?.setFieldValue("quotation_type", "external");
      formikQuotationFcl?.setFieldValue("date", getCurrentDate());

      setServiceType(updatedCardData);
    }
  };

  return (
    <GenerateQuotationComponent
      quotationTypes={quotationTypes}
      serviceTypes={serviceTypes}
      handleCardClick={handleCardClick}
      clicked={clicked}
    />
  );
};

export default GenerateQuotationContainer;
